import { render } from "./DashboardLab.vue?vue&type=template&id=661ae83c&scoped=true"
import script from "./DashboardLab.vue?vue&type=script&lang=js"
export * from "./DashboardLab.vue?vue&type=script&lang=js"

import "./DashboardLab.vue?vue&type=style&index=0&id=661ae83c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661ae83c"]])

export default __exports__